import React, { Component } from 'react';
import { connect } from 'react-redux';
import BobModal from '../../../components/BobModal';

class DeleteAnnouncementModal extends Component {

    deleteAnnouncement = async () => {
        this.props.close();    
        this.props.handleDelete();    
    }

    handleClose = () => {
        this.props.close();
    }

    render() {
        const {open, title, message, errors} = this.props;

        return (
            <BobModal
                errors={errors}
                confirmText="Confirm"
                rootClass={'announcement-delete-modal'}
                onCancel={this.handleClose}
                onClose={this.handleClose}
                onConfirm={this.deleteAnnouncement}
                open={open}
                title={title}
            >
                {message}
            </BobModal>
        );
    }
}

const mapStateToProps = state => {
    return {

    };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAnnouncementModal);
